// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import HeaderButton from './js/widgets/HeaderButton.js';
import videoWidget from './js/widgets/videoWidget.js';
import cardWidget from './js/widgets/cardWidget.js';
import sponsorWidgetContainer from './js/widgets/cssSponsors.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    cardWidget();  
    multiScheduleFeature();
    swiperWidget();
    seoWidget();
 
    sponsorWidgetContainer();
    videoWidget();
  });
}
if (window.location.pathname === '/') {
  $(window).on('load', function() {
  HeaderButton(); 

});
}